module.exports = __webpack_public_path__ + "static/media/login.6754a653.png";